import { API } from 'utils/api.config';

export async function getBannerApi() {
    return await API.get(`api/banner`, {
        params: { type: 'web' }
    });
}
